import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, vShow as _vShow, withDirectives as _withDirectives, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-3036958e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "section-content" }
const _hoisted_2 = { class: "option-group" }
const _hoisted_3 = { class: "option-label" }
const _hoisted_4 = { class: "option-row radio-with-sub" }
const _hoisted_5 = { class: "sub-options" }
const _hoisted_6 = { class: "option-group" }
const _hoisted_7 = { class: "option-label" }
const _hoisted_8 = {
  key: 0,
  class: "option-group"
}
const _hoisted_9 = { class: "option-label" }
const _hoisted_10 = {
  key: 1,
  class: "option-group"
}
const _hoisted_11 = { class: "option-label" }
const _hoisted_12 = {
  key: 2,
  class: "option-group"
}
const _hoisted_13 = { class: "option-label" }

import { computed, PropType } from 'vue'
import { useI18n } from 'vue-i18n'
import type { SystemProtectionSettings } from '../../group-policy-settings.service'
import { SpyMode } from './system-protection.service'
import { IS_JP_ONLY_BUILD } from '@/common/const/build-locale'


export default /*#__PURE__*/_defineComponent({
  __name: 'system-protection',
  props: {
  modelValue: {
    type: Object as PropType<SystemProtectionSettings>,
    required: true
  },
  readonly: {
    type: Boolean,
    default: false
  }
},
  emits: ['update:modelValue', 'change'],
  setup(__props, { emit: __emit }) {

const { t } = useI18n()

const props = __props

const emits = __emit

const strategy = computed({
  get: () => props.modelValue,
  set: (val) => emits('update:modelValue', val)
})

function handleChange() {
  emits('change')
}

function handleFullScanClick() {
  if (props.readonly) return
  strategy.value.spy_mode = SpyMode.fullV2
  handleChange()
}

return (_ctx: any,_cache: any) => {
  const _component_el_radio = _resolveComponent("el-radio")!
  const _component_el_checkbox = _resolveComponent("el-checkbox")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, _toDisplayString(_unref(t)('groupPolicySettings.sysMonitorModeTitle')), 1),
      _createVNode(_component_el_radio, {
        class: "option-row",
        modelValue: strategy.value.spy_mode,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((strategy.value.spy_mode) = $event)),
        modelModifiers: { number: true },
        label: _unref(SpyMode).smart,
        disabled: __props.readonly,
        onChange: handleChange
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_unref(t)('groupPolicySettings.sysSmartMonitor')), 1),
          _createElementVNode("strong", null, _toDisplayString(_unref(t)('groupPolicySettings.sysRecTag')), 1)
        ]),
        _: 1
      }, 8, ["modelValue", "label", "disabled"]),
      (!_unref(IS_JP_ONLY_BUILD))
        ? (_openBlock(), _createBlock(_component_el_radio, {
            key: 0,
            class: "option-row",
            modelValue: strategy.value.spy_mode,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((strategy.value.spy_mode) = $event)),
            modelModifiers: { number: true },
            label: _unref(SpyMode).normal,
            disabled: __props.readonly,
            onChange: handleChange
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_unref(t)('groupPolicySettings.sysNormalMonitor')), 1)
            ]),
            _: 1
          }, 8, ["modelValue", "label", "disabled"]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_component_el_radio, {
          onClick: handleFullScanClick,
          "model-value": strategy.value.spy_mode === _unref(SpyMode).fullV2 || strategy.value.spy_mode === _unref(SpyMode).fullV3,
          label: true,
          disabled: __props.readonly
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_unref(t)('groupPolicySettings.sysFullDiskMonitor')), 1)
          ]),
          _: 1
        }, 8, ["model-value", "disabled"]),
        _withDirectives(_createElementVNode("div", _hoisted_5, [
          _createVNode(_component_el_radio, {
            class: "option-row",
            modelValue: strategy.value.spy_mode,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((strategy.value.spy_mode) = $event)),
            modelModifiers: { number: true },
            label: _unref(SpyMode).fullV2,
            disabled: __props.readonly,
            onChange: handleChange
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_unref(t)('groupPolicySettings.sysMonExecCreate')), 1)
            ]),
            _: 1
          }, 8, ["modelValue", "label", "disabled"]),
          _createVNode(_component_el_radio, {
            class: "option-row",
            modelValue: strategy.value.spy_mode,
            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((strategy.value.spy_mode) = $event)),
            modelModifiers: { number: true },
            label: _unref(SpyMode).fullV3,
            disabled: __props.readonly,
            onChange: handleChange
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_unref(t)('groupPolicySettings.sysMonAllOps')), 1)
            ]),
            _: 1
          }, 8, ["modelValue", "label", "disabled"])
        ], 512), [
          [_vShow, strategy.value.spy_mode === _unref(SpyMode).fullV2 || strategy.value.spy_mode === _unref(SpyMode).fullV3]
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_6, [
      _createElementVNode("div", _hoisted_7, _toDisplayString(_unref(t)('groupPolicySettings.sysSecurityFuncTitle')), 1),
      _createVNode(_component_el_checkbox, {
        class: "option-row",
        modelValue: strategy.value.kernel_stable,
        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((strategy.value.kernel_stable) = $event)),
        modelModifiers: { number: true },
        "true-label": 1,
        "false-label": 0,
        disabled: __props.readonly,
        onChange: handleChange
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_unref(t)('groupPolicySettings.sysKernelHarden')), 1)
        ]),
        _: 1
      }, 8, ["modelValue", "disabled"]),
      _createVNode(_component_el_checkbox, {
        class: "option-row",
        modelValue: strategy.value.office_remind,
        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((strategy.value.office_remind) = $event)),
        modelModifiers: { number: true },
        "true-label": 1,
        "false-label": 0,
        disabled: __props.readonly,
        onChange: handleChange
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_unref(t)('groupPolicySettings.sysOfficeDocTip')), 1)
        ]),
        _: 1
      }, 8, ["modelValue", "disabled"])
    ]),
    (0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
          _createElementVNode("div", _hoisted_9, _toDisplayString(_unref(t)('groupPolicySettings.sysRansomwareTitle')), 1),
          _createVNode(_component_el_checkbox, {
            class: "option-row",
            modelValue: strategy.value.extort_protect,
            "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((strategy.value.extort_protect) = $event)),
            modelModifiers: { number: true },
            "true-label": 1,
            "false-label": 0,
            disabled: __props.readonly,
            onChange: handleChange
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_unref(t)('groupPolicySettings.sysRansomDecoy')), 1)
            ]),
            _: 1
          }, 8, ["modelValue", "disabled"])
        ]))
      : _createCommentVNode("", true),
    (!_unref(IS_JP_ONLY_BUILD))
      ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
          _createElementVNode("div", _hoisted_11, _toDisplayString(_unref(t)('groupPolicySettings.sysPopupBlockTitle')), 1),
          _createVNode(_component_el_checkbox, {
            class: "option-row",
            modelValue: strategy.value.auto_block_pop,
            "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((strategy.value.auto_block_pop) = $event)),
            modelModifiers: { number: true },
            "true-label": 1,
            "false-label": 0,
            disabled: __props.readonly,
            onChange: handleChange
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_unref(t)('groupPolicySettings.sysPopupAutoBlock')), 1)
            ]),
            _: 1
          }, 8, ["modelValue", "disabled"])
        ]))
      : _createCommentVNode("", true),
    (!_unref(IS_JP_ONLY_BUILD))
      ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
          _createElementVNode("div", _hoisted_13, _toDisplayString(_unref(t)('groupPolicySettings.sysSoftInstallTitle')), 1),
          _createVNode(_component_el_checkbox, {
            class: "option-row",
            modelValue: strategy.value.soft_install_tips,
            "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((strategy.value.soft_install_tips) = $event)),
            modelModifiers: { number: true },
            "true-label": 1,
            "false-label": 0,
            disabled: __props.readonly,
            onChange: handleChange
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_unref(t)('groupPolicySettings.sysSoftInstallWarn')), 1)
            ]),
            _: 1
          }, 8, ["modelValue", "disabled"])
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})